module.exports = __webpack_public_path__ + "img/coming.a51ad9f9.png";